import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { DropDownListModule } from '@progress/kendo-angular-dropdowns';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { KendoDropdownTreeviewComponent } from './components/kendo-dropdown-treeview/kendo-dropdown-treeview.component';
import { KendoStepperComponent } from './components/kendo-stepper/kendo-stepper.component';
import { StepperDirective } from './components/kendo-stepper/kendo-step/stepper-host.directive';
import { CommunicationConfigService } from './services/communication-config/communication-config.service';
import { ConfigService, ConfigServiceOption } from './services/config/config.service';
import { HttpInterceptorService } from './services/http-interceptor/http-interceptor.service';
import { ThemeService } from './services/theme/theme.service';
import { ToolsService } from './services/tools/tools.service';
import { KendoProgressBarComponent } from './components/kendo-progress-bar/kendo-progress-bar.component';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { WindowModule } from '@progress/kendo-angular-dialog';
import { KendoGridListComponent } from './components/kendo-grid-list/kendo-grid-list.component';
import { GridModule, ExcelModule } from '@progress/kendo-angular-grid';
import { FilArianeComponent } from './components/fil-ariane/fil-ariane.component';
import { RouterModule } from '@angular/router';
import { ExtranetHeaderComponent } from './components/extranet-header/extranet-header.component';
import { TopbarComponent } from './components/extranet-header/topbar/topbar.component';
import { SignoutDialogComponent } from './components/extranet-header/signout-dialog/signout-dialog.component';
import { ExtranetSidemenuComponent } from './components/extranet-sidemenu/extranet-sidemenu.component';
import { CsrfService } from './services/csrf/csrf.service';
import { IsSigninService } from './services/is-signin/is-signin.service';
import { LoadingComponent } from './components/loading/loading.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { NgxDropzoneComponent, NgxDropzoneLabelDirective, NgxDropzonePreviewComponent } from 'ngx-dropzone-next';
import { KendoWindowTitlebarComponent } from './components/kendo-window-titlebar/kendo-window-titlebar.component';
import { DynamicCssComponent } from './components/dynamic-css/dynamic-css.component';
import { DynamicCssService } from './services/dynamic-css/dynamic-css.service';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { StatePersistingService } from './services/grid-state/grid-state.service';

@NgModule({ declarations: [
        KendoDropdownTreeviewComponent,
        StepperDirective,
        KendoStepperComponent,
        KendoProgressBarComponent,
        KendoGridListComponent,
        FilArianeComponent,
        ExtranetHeaderComponent,
        TopbarComponent,
        SignoutDialogComponent,
        ExtranetSidemenuComponent,
        ExtranetSidemenuComponent,
        LoadingComponent,
        UploadFileComponent,
        KendoWindowTitlebarComponent,
        DynamicCssComponent
    ],
    exports: [
        KendoDropdownTreeviewComponent,
        StepperDirective,
        KendoStepperComponent,
        KendoProgressBarComponent,
        KendoGridListComponent,
        FilArianeComponent,
        ExtranetHeaderComponent,
        TopbarComponent,
        SignoutDialogComponent,
        ExtranetSidemenuComponent,
        LoadingComponent,
        UploadFileComponent,
        KendoWindowTitlebarComponent,
        DynamicCssComponent
    ], imports: [
        CommonModule,
        TreeViewModule,
        DropDownListModule,
        TabStripModule,
        WindowModule,
        ButtonsModule,
        GridModule,
        DialogModule,
        RouterModule,
        NgxDropzoneComponent, 
        NgxDropzoneLabelDirective, 
        NgxDropzonePreviewComponent,
        ExcelExportModule,
        ExcelModule
      ], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class GlobalModule {
  constructor(@Optional() @SkipSelf() parentModule: GlobalModule) {
    if (parentModule) {
      throw new Error('GlobalModule is already loaded. Import it in the AppModule only');
    }
  }

  public static forRoot(
    useHttpInterceptor = false,
    config?: ConfigServiceOption
  ): ModuleWithProviders<GlobalModule> {
    return {
      ngModule: GlobalModule,
      providers: [
        ThemeService,
        ToolsService,
        ConfigService,
        CommunicationConfigService,
        DynamicCssService,
        {
          provide: ConfigServiceOption,
          useValue: config
        },
        CsrfService,
        IsSigninService,
        StatePersistingService,
        useHttpInterceptor
          ? {
              provide: HTTP_INTERCEPTORS,
              useClass: HttpInterceptorService,
              multi: true
            }
          : void 0
      ]
    };
  }
}
